module.exports = __webpack_public_path__ + "img/103.9426967b.jpg";